module.exports = __webpack_public_path__ + "img/logo-full.c13f016e.png";